import { render } from "./SimilarSentencesPopUp.vue?vue&type=template&id=44c00fe8&scoped=true"
import script from "./SimilarSentencesPopUp.vue?vue&type=script&lang=js"
export * from "./SimilarSentencesPopUp.vue?vue&type=script&lang=js"

import "./SimilarSentencesPopUp.vue?vue&type=style&index=0&id=44c00fe8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c00fe8"]])

export default __exports__